import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { globalFileServer } from "../../../../axiosInstance";
import { setCategoryFilters } from "../../../server/Product";
import {
  applyCategoryFilters,
  buildEntityCountMap,
  isCategoryFilterSelected,
  isSameFilterId,
  normalizeFilterId,
} from "./categoryFilterUtils";

// Stable fallback so the selector doesn't return a new [] on every call.
const EMPTY_FILTERS = [];

const ProductFilterInside = ({ title, parameterName }) => {
  const dispatch = useDispatch();
  const categoryFilters = useSelector(
    (state) => state.displayProduct.categoryFilters ?? EMPTY_FILTERS,
  );
  const categoryItemsSource = useSelector(
    (state) => state.displayProduct.categoryItemsSource,
  );
  const reloed = useSelector((state) => state.displayProduct.reloed);

  const quantityMap = useMemo(() => {
    if (!categoryItemsSource || reloed) return {};

    const filtersWithoutMe = categoryFilters.filter(
      (filter) => filter.parameterName !== parameterName,
    );
    const scopedTree = applyCategoryFilters(
      categoryItemsSource,
      filtersWithoutMe,
    );

    return buildEntityCountMap(scopedTree, parameterName);
  }, [categoryFilters, categoryItemsSource, parameterName, reloed]);

  const toggleFilter = (selectedId) => {
    const normalizedId = normalizeFilterId(selectedId);
    const exists = isCategoryFilterSelected(
      categoryFilters,
      parameterName,
      normalizedId,
    );

    const nextFilters = exists
      ? categoryFilters.filter(
          (filter) =>
            !(
              filter.parameterName === parameterName &&
              isSameFilterId(filter.id, normalizedId)
            ),
        )
      : [...categoryFilters, { parameterName, id: normalizedId }];

    dispatch(setCategoryFilters(nextFilters));
  };

  if (Object.keys(quantityMap).length === 0) {
    return null;
  }

  return (
    <div className="item">
      <div className="wrapper">
        <h2>{title}</h2>
        <div className="wrap">
          <ul>
            {Object.entries(quantityMap).map(
              ([key, { id, name, quantity }]) => {
                const isActive = isCategoryFilterSelected(
                  categoryFilters,
                  parameterName,
                  id,
                );

                return (
                  <li
                    key={key}
                    data-class={!quantity ? "disabled" : null}
                    className={isActive ? "active" : null}
                  >
                    <span>{name}</span>
                    <span className="quantity">{"(" + quantity + ")"}</span>
                    <div
                      className="input"
                      onClick={() => (quantity ? toggleFilter(id) : null)}
                    >
                      {isActive ? (
                        <img
                          loading="lazy"
                          src={globalFileServer + "iconcss/done.svg"}
                          alt="done"
                        />
                      ) : null}
                    </div>
                  </li>
                );
              },
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductFilterInside;
